import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"min-height":"250px"} }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "未找到相关的资源", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "请扫码联系魔欢平台反馈所需歌曲", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "title"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "未找到相关的资源", -1)

import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { commonServiceRequest } from '@/utils/http/common-service'
import { onMounted, ref, computed } from 'vue'
import { message } from 'ant-design-vue'
import store from '../../store'
import logo from '../../assets/qr-icon.png'

export default /*#__PURE__*/_defineComponent({
  props: {
  value: Boolean,
  title: String
},
  setup(__props) {

const props = __props
const loading = ref(false)
const qrcodeUrl = ref('')

const isFirst = computed(() => props.value)
const title = computed(() => props?.title)

onMounted(async () => {
  if (store.state.keFuWechatQrCodeUrl === '') {
    loading.value = true
    try {
      const res: any = await commonServiceRequest(
        'GET',
        '/getKefuWechatQRCode',
        ''
      )
      store.commit('setKeFuQRCodeUrl', res.qrcode_url)
      qrcodeUrl.value = res.qrcode_url
    } catch (error) {
      message.error('生成客服二维码失败')
    }
  } else {
    qrcodeUrl.value = store.state.keFuWechatQrCodeUrl
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: loading.value }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(vueQr, {
            text: qrcodeUrl.value,
            correctLevel: 3,
            size: 150,
            logoSrc: _unref(logo),
            margin: 10,
            logoScale: 0.3,
            logoMargin: 0
          }, null, 8, ["text", "logoSrc", "logoScale"]),
          (!_unref(title))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", null, _toDisplayString(_unref(title)), 1)
              ]))
        ], 512), [
          [_vShow, _unref(isFirst)]
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})